import React from "react";
import { ChevronRight } from "lucide-react";

export default function SettingsChevron({ className = "" }) {
  return (
    <ChevronRight
      aria-hidden
      strokeWidth={2.35}
      className={["h-5 w-5 text-on-surface opacity-85", className].join(" ").trim()}
    />
  );
}
